<template>
  <el-dialog :append-to-body="true" :visible.sync="isShow" :show-close="false" width="550px" custom-class="public-pool-drop-actived-dialog" @closed="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
      <h1 class="title">你可以设置以下来源的客户不受公客池掉落规则限制</h1>
      <i class="el-icon-close" style="cursor: pointer;" @click="closed"></i>
    </div>
    <div class="platform-con">
      <el-tree :data="platList" node-key="code" class="yorker-tree" :default-checked-keys="defaultChecked" ref="treeRef" :props="defaultProps" :expand-on-click-node="false" :default-expand-all="false" show-checkbox>
        <span class="custom-tree-node" slot-scope="{ node, data }">
          {{ data.name }}
        </span>
      </el-tree>
    </div>
    <div class="btn-groups">
      <el-button class="global-btn primary" @click="handleSave">保存</el-button>
      <el-button class="global-btn info-round" @click="closed">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {getPublicPoolPlatform} from '@/api/system';
export default{
  name: 'PlatformPicker',
  data () {
    return {
      isShow: false,
      platList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      defaultChecked: []
    }
  },
  methods: {
    open (list) {
      this.isShow = true;
      this.initPlatform(list);
    },
    closed () {
      this.isShow = false;
      this.platList = [];
    },
    async initPlatform (list) {
      try {
        const res = await getPublicPoolPlatform();
        this.platList = res;
        if (list.length > 0) {
          this.defaultChecked = list;
        }
      } catch (error) {
        this.platList = [];
        this.$message.error(error.msg || '操作错误，请重试');
      }
    },
    handleSave () {
      // 获取选中文本
      const nodes = this.$refs.treeRef.getCheckedNodes(false, false);
      if (nodes.length <= 0) {
        this.$emit('confirm', {list: [], text: ''});
        this.closed();
        return null;
      }
      const checked = {};
      this.platList.map((v, i) => {
        // 判断最外层是否包含
        const exits = nodes.findIndex(a => a.code == v.code);
        checked[v.code] = {
          code: v.code,
          name: v.name,
          chekced: exits >= 0,
          children: []
        }
        // 外层未选中则继续循环子级
        if (exits < 0) {
          if (v.children && v.children.length > 0) {
            v.children.map(b => {
              this.generateText({
                node: b,
                checkList: nodes,
                list: checked,
                code: v.code
              });
            })
          }
        }
      })
      // 拼接展示内容
      const textList = [];
      Object.keys(checked).map((v, i) => {
        const item = checked[v];
        if (item.chekced || item.children.length > 0) {
          textList.push(`${item.name}${item.children.length > 0 ? '-' + item.children.map(a => a.name).join('/') : ''}`);
        }
      })
      const idList = nodes.map(v => v.code);
      this.$emit('confirm', {list: idList, text: textList.join(';')});
      this.closed();
    },
    generateText ({checkList, node, list, code}) {
      const exits = checkList.findIndex(a => a.code == node.code);
      if (exits >= 0) {
        list[code].children.push({
          name: node.name
        })
      } else {
        if (node.children && node.children.length > 0) {
          node.children.map((b, i) => {
            this.generateText({
              node: b,
              checkList,
              list,
              code
            });
          })
        }
      }
    }
  },
}
</script>
<style lang="less" scoped>
.platform-con{
  margin-top: -8px;
  padding: 10px 30px;
  height: 500px;
  overflow-y: scroll;
}
.btn-groups{
  padding: 20px;
  text-align: center;
  button{
    width: 100px;
    height: 35px;
  }
}
</style>